import React from "react";

export default function LoadingScreen() {
  return (
    <div className="w-full h-full min-h-[250px] flex flex-col items-center justify-center gap-3.5 bg-transparent z-50">
      
      {/* 3-Dot Smooth Wave */}
      <div className="flex items-center gap-2">
        <div className="w-2.5 h-2.5 bg-primary rounded-full animate-[bounce_1s_infinite_-0.3s]"></div>
        <div className="w-2.5 h-2.5 bg-primary/80 rounded-full animate-[bounce_1s_infinite_-0.15s]"></div>
        <div className="w-2.5 h-2.5 bg-primary/60 rounded-full animate-[bounce_1s_infinite]"></div>
      </div>

      {/* Ledger-style Label */}
      <span className="text-[10px] font-bold text-[#6B7280] uppercase tracking-[0.25em] ml-1">
        Loading...
      </span>
      
    </div>
  );
}